export const INVENTORY_PAGES_ORDER_FOR_PERMISSIONS: string[] = ['public_agent_module_permission', 'group_module_permission']
